import {override} from "mobx";
import {APP} from "../../../../../core/app/consts";
import type {ImageRequestParams} from "../../../../../infrastructure/models/params/image-request-params";
import {TopTrendFlameImageRequestParams} from "../../../../../widgets/trends-widget/models/assets/top-trend-flame-image.request-params";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {GameCenterTabModel} from "./game-center.tab-model";

export class GameCenterTrendsTabModel extends GameCenterTabModel {
  @override get isVisible(): Boolean {
    return this.entity.hasTrends;
  }

  get eventParams(): Object {
    const eventParams = {
      gameId: this.entity.id,
      entityId: this.entity.id,
      status: this.entity.statusGroup,
      source: APP.ANALYTICS.SOURCES.gameCenterTabs,
    }

    return eventParams;
  }

  get iconSource(): ImageRequestParams {
    return new TopTrendFlameImageRequestParams();
  }

  get isIconFirst(): ImageRequestParams {
    return true;
  }

  get hasIcon(): Boolean {
    return this.entity.hasTopTrends;
  }

  get isNoFollow(): Boolean {
    return true;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.trends;
  }

  get elementId(): String {
    return 'navigation-tabs_game-center_trends';
  }

  get eventName(): String {
    return null
  }
}
